import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeNav } from '../../../redux/nav';
import TakeoverDrawer from '../SiteTakeovers/TakeoverDrawer';
import takeover from '../../../hocs/takeover';

import Accordion from '../Accordion/Accordion';

export class NavDrawer extends Component {
  static propTypes = {
    closeNav: PropTypes.func.isRequired,
    nodes: PropTypes.array,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    isOpen: false,
  };

  render() {
    const { closeNav, isOpen, nodes = [] } = this.props;

    let navKey = nodes.reduce((accum, element) => `${accum}${element.id},`, '');

    return (
      <TakeoverDrawer
        direction="left"
        maxWidth="22.5rem"
        open={isOpen}
        overlayClick={closeNav}
        overlayColor="rgba(51, 51, 51, 0.2)"
      >
        <Accordion key={isOpen} nodes={nodes} />
      </TakeoverDrawer>
    );
  }
}

export const NavDrawerTakeover = takeover(NavDrawer, 'isOpen');

const mapStateToProps = ({ nav: { open } }) => ({
  isOpen: open,
});

const mapDispatchToProps = { closeNav };

export default connect(mapStateToProps, mapDispatchToProps)(NavDrawerTakeover);
